<template>
<h1>登录</h1>
</template>

<script>
export default {
    name:'Login'
}
</script>


// WEBPACK FOOTER //
// src/views/Login.vue